import React from 'react';
import './App.css';
import Router from './routers';
import routes from './routers/routes';
import dayjs from 'dayjs';
import Menu from './components/Menu';
import { styled } from '@mui/material/styles';
import Footer from './components/Footer';
import CloseIcon from '@mui/icons-material/Close';
import { Stack, Modal, Box, Button, IconButton } from '@mui/material';
import Image from './components/Image';
import { useNavigate } from 'react-router-dom';

const visibleUntil = 'Fri Apr 05 2024 23:59:00 GMT-0600 (Central Standard Time)';

function App() {
  const [openAlert, setOpenAlert] = React.useState(true);
  const navigate = useNavigate();
  const currentDate = new Date();

  const convocatoriaMS = () => {
    setOpenAlert(false);
    navigate(routes.lemMS)
  }
  
  return (
    <div className="App">
      <Menu />
      <Stack sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '18px',
      }}>

        <Router />
      </Stack>
      <Footer />
      {openAlert && dayjs(currentDate) < dayjs(visibleUntil) && 
      <Modal
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: '800px',
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            pt: 4,
            px: 4,
            pb: 3,
          }}>
            <IconButton sx={{position: 'absolute', right: '8px', top: '8px'}} aria-label="close" onClick={() => setOpenAlert(false)}><CloseIcon /></IconButton>
            <Image
            sx={{ maxWidth: '1200px', objectFit: 'contain' }}
            mt={2}
            src="https://s3.amazonaws.com/lideresenmovimiento.s3/lemms24_ampliar.png"
            alt="La convocatoria media superior ha sido ampliada"
          />
            <Button variant="contained" onClick={convocatoriaMS} sx={{mt: 2}}>
              Visita la convocatoria
            </Button>
          </Box>
      </Modal>}
    </div>
  );
}

export default App;
